import { Link } from "react-router-dom";

const GulfStudentsData = [
    {
        id: 1,
        bannerImg: require("../../Assets/Gulf_Students/Pre-Departure-Toolkit.png"),
        heading: "Pre-Departure Toolkit",
        text: "Visa checklists, travel prep guides, and cultural orientation webinars to help you arrive confident and ready.",
        link: <Link to={"/gulf-students/pre-departure"}><p className="our-services-card-link">Learn More</p></Link>
    },
    {
        id: 2,
        bannerImg: require("../../Assets/Gulf_Students/Academic-Readiness.png"),
        heading: "Academic Readiness",
        text: "14-day email course covering study skills, writing conventions, and U.S. classroom expectations.",
        link: <Link to={"/gulf-students/academic-readiness"}><p className="our-services-card-link">Join The Bootcamp</p></Link>
    },
    {
        id: 3,
        bannerImg: require("../../Assets/Gulf_Students/Peer-Mentorship-Network.png"),
        heading: "Peer Mentorship Network",
        text: "Connect with Gulf alumni already studying in various countries for advice, support, and insider tips.",
        link: <Link to={"/gulf-students/mentorship"}><p className="our-services-card-link">Meet Your Mentors</p></Link>
    },
    {
        id: 4,
        bannerImg: require("../../Assets/Gulf_Students/Career-&-Internship-Prep.png"),
        heading: "Career & Internship Prep",
        text: "Resume clinics, LinkedIn audits, and CPT/OPT guidance to help you build your professional path.",
        link: <Link to={"/gulf-students/career-prep"}><p className="our-services-card-link">Get Career-Ready</p></Link>
    },
    {
        id: 5,
        bannerImg: require("../../Assets/Gulf_Students/Resource-Vault.png"),
        heading: "Resource Vault",
        text: "Download planners, templates, and guides built for Gulf students studying abroad.",
        link: <Link to={"/gulf-students/resource-vault"}><p className="our-services-card-link">Access the Vault</p></Link>
    },
];

export default GulfStudentsData;